import { BASEPATH } from "../../utils/constants/constants";

export const ADDITIONAL_MF_REPORTING_URL = {
  GET_REPORT_LIST: `${BASEPATH}/reports/searchAdditionalMainframeReports`,
  UPLOAD_REPORT: `${BASEPATH}/reports/uploadAdditionalMainframeReport`,
};
